import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Inset } from 'syf-component-library/ui/spacing';
import formatCurrency from 'syf-js-utilities/formats/formatCurrency';
import { spendingTrendsCategoryIcons, spendingTrendsColors } from '../../../const/spending-trends';
import useDeviceWidth from '../../../hooks/use-device-width';
import { StyledFlex } from '../../../styles/common';
import { StyledText, StyledTitle } from '../../../styles/text';
import { colors } from '../../../styles/theme';
import { getCategoryTranslationLabel } from '../../../helpers/spending-trends';
import TableList from '../../common/table-list';
import { SpendingTrendsStyledRow, StyledBorder } from '../drawer/subcomponents';
import { LastColumnHeader, RowContent } from './common';
import SpendingTrendsMobileTable from './mobile';
import { StyledIconContainer, StyledInset } from './subcomponents';
var FirstCell = function (_a) {
    var borderColor = _a.borderColor, category = _a.category, isSelected = _a.isSelected;
    var t = useTranslation().t;
    var CATEGORY_TRANSLATION_LABEL = getCategoryTranslationLabel(category);
    return (_jsx(TableList.Cell, { textAlign: "left", children: _jsxs(StyledFlex, { justifyContent: "start", children: [_jsx(StyledBorder, { isSelected: isSelected, color: borderColor }), _jsxs(StyledFlex, { alignItems: "center", children: [_jsx(StyledInset, { left: "base", right: "medium", children: _jsx(StyledIconContainer, { color: borderColor, children: _jsx(FontAwesomeIcon, { icon: spendingTrendsCategoryIcons[category] }) }) }), _jsx(StyledText, { color: colors.black, weight: "semiBold", children: t(CATEGORY_TRANSLATION_LABEL) })] })] }) }));
};
var TableRow = function (_a) {
    var tableData = _a.tableData, selectedCategory = _a.selectedCategory;
    return (_jsx(_Fragment, { children: tableData.map(function (_a) {
            var borderColor = _a.borderColor, category = _a.category, percentage = _a.percentage, amount = _a.amount;
            return (_jsxs(SpendingTrendsStyledRow, { hideTopBorder: true, children: [_jsx(FirstCell, { borderColor: borderColor, category: category, spendingPercentage: percentage, isSelected: category === selectedCategory }), _jsx(RowContent, { cellValue: percentage }), _jsx(RowContent, { fontWeight: "bold", textAlign: "right", cellValue: formatCurrency(amount) })] }, category));
        }) }));
};
var ColumnHeaders = function (_a) {
    var _b = _a.textAlign, textAlign = _b === void 0 ? 'left' : _b, headerName = _a.headerName;
    return (_jsx(TableList.ColumnHeader, { background: spendingTrendsColors.backgroundTableHeader, textAlign: textAlign, whiteSpace: "nowrap", children: _jsx(StyledFlex, { direction: "row", alignItems: "flex-start", children: _jsx(Inset, { all: "small", children: _jsx(StyledTitle, { color: "black", children: headerName }) }) }) }));
};
var TableHeader = function (_a) {
    var headerList = _a.headerList, toggleOrder = _a.toggleOrder, currentSort = _a.currentSort;
    var firstHeaderName = headerList[0], SecondHeaderName = headerList[1], ThirdHeaderName = headerList[2];
    return (_jsxs(SpendingTrendsStyledRow, { hideBottomBorder: true, children: [_jsx(ColumnHeaders, { headerName: firstHeaderName }, firstHeaderName), _jsx(ColumnHeaders, { headerName: SecondHeaderName }, SecondHeaderName), _jsx(LastColumnHeader, { onClick: toggleOrder, currentSort: currentSort, item: ThirdHeaderName }, ThirdHeaderName)] }));
};
var SpendingTrendsTable = function (_a) {
    var tableData = _a.tableData, selectedCategory = _a.selectedCategory;
    var isMobile = useDeviceWidth();
    var t = useTranslation().t;
    var _b = useState('asc'), currentSort = _b[0], setCurrentSort = _b[1];
    var toggleOrder = function () {
        setCurrentSort(function (prev) { return (prev === 'asc' ? 'desc' : 'asc'); });
    };
    var desktopColumnHeaders = [
        t('spendingTrends.categoriesTableHeader'),
        t('spendingTrends.percentSpentTableHeader'),
        t('spendingTrends.amountTableHeader')
    ];
    var sorteredTableData = tableData.sort(function (a, b) {
        var amountA = parseFloat(a.amount);
        var amountB = parseFloat(b.amount);
        return currentSort === 'desc' ? amountA - amountB : amountB - amountA;
    });
    if (!isMobile) {
        return (_jsx(Inset, { all: "large", children: _jsxs(TableList, { children: [_jsx(TableHeader, { currentSort: currentSort, headerList: desktopColumnHeaders, toggleOrder: toggleOrder }), sorteredTableData && (_jsx(TableRow, { tableData: sorteredTableData, selectedCategory: selectedCategory }))] }) }));
    }
    return (_jsx(SpendingTrendsMobileTable, { tableData: sorteredTableData, currentSort: currentSort, toggleOrder: toggleOrder, selectedCategory: selectedCategory }));
};
export default SpendingTrendsTable;
//# sourceMappingURL=index.js.map